import { actionTypeCreator, stateChangeOnlyActionTypeCreator } from '../../store/actionCreators';

export const GET_ALL_USER_ACTIONTYPE = actionTypeCreator('users/all');
export const GET_ACTIVE_USER_DETAILS = actionTypeCreator('user/active/get');
export const GET_USER_DETAILS_ACTIONTYPE = actionTypeCreator('user/get');
export const UPDATE_USER_STATUS_ACTIONTYPE = actionTypeCreator('user/status');
export const ADD_NEW_USER_ACTIONTYPE = actionTypeCreator('user/new');
export const UPDATE_USER_ACTIONTYPE = actionTypeCreator('user/update');
export const DELETE_USER_ACTIONTYPE = actionTypeCreator('user/delete');
export const CHANGE_SUPERVISOR_ACTIONTYPE = actionTypeCreator('user/changeSupervisor');
export const RESET_TELEGRAM_DETAILS_ACTIONTYPE = actionTypeCreator('user/resetTelegram');
export const SET_SMS_ALERTS_TO_USER_ACTIONTYPE = actionTypeCreator('user/sendSMS')
export const UPDATE_PASSWORD_FOR_USER_ACTIONTYPE = actionTypeCreator('user/updatePassword')
export const UPDATE_LABEL_DEFINITION_ACTIONTYPE = actionTypeCreator('user/updateLabelDefinition')

export const SET_ACTIVE_USER_UUID_ACTIONTYPE = stateChangeOnlyActionTypeCreator('user/setActive');
export const TRIGGER_USER_ENTITY_DIALOG_ACXTIONTYPE = stateChangeOnlyActionTypeCreator('user/entityDialog');
export const SHOW_OVERVIEW_POPOVER_ACTIONTYPE = stateChangeOnlyActionTypeCreator('user/overview/popover');
export const SHOW_ADDDEVICE_POPOVER_ACTIONTYPE = stateChangeOnlyActionTypeCreator('user/addDevice/popover');
